import TYPES from '@/modules/shared/types';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';
import { CustomerOverviewRepository } from '../../domain/repositories/customer-overview-repository';
import { CustomerOverviewEntity } from '../../domain/entities/customer-overview-entity';

@Injectable()
export default class CustomerOverviewHttpRepository implements CustomerOverviewRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/dashboard/customer-overview/`;

  get_customer_overview(): Promise<CustomerOverviewEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }
}
